import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetDoctorSaleEntriesParams {
  doctorId?: string;
  timeHead?: string;
  timeTail?: string;
}

export function getDoctorSale(params: GetDoctorSaleEntriesParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorSaleList`,
    method: "GET",
    params,
  };
}
